export default function FloatingPaws() {
  const paws = Array.from({ length: 12 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 20}s`,
    animationDuration: `${15 + Math.random() * 10}s`,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none -z-5">
      {paws.map((paw) => (
        <div
          key={paw.id}
          className="absolute text-4xl opacity-[0.08] animate-float"
          style={{
            left: paw.left,
            top: '-50px',
            animationDelay: paw.animationDelay,
            animationDuration: paw.animationDuration,
          }}
        >
          🐾
        </div>
      ))}
    </div>
  );
}
